import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ChevronRight } from 'lucide-vue-next';
    import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkMarkAsMissingVouchers',
  props: {
    selectedVouchers: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const props = __props;

    const invalidVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => !voucher.valid_for_marking_as_missing),
    );

    const validVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => voucher.valid_for_marking_as_missing),
    );

    const markAsMissing = () => {
        if (invalidVouchers.value.length) {
            toast.error(t('vouchers.select.mark_as_missing_confirm.invalid_header'), {
                description: t('vouchers.select.mark_as_missing_confirm.invalid_description', {
                    body: invalidVouchers.value
                        .map((voucher) => `#${voucher.VoucherNumber}`)
                        .join(', '),
                }),
            });
            return;
        }

        voucherStore.setValidVouchers(validVouchers.value);
        voucherStore.toggleOpen('mark_as_missing', true);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenuItem), { onClick: markAsMissing }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('vouchers.select.mark_as_missing')) + " ", 1),
      _createVNode(_unref(ChevronRight), { class: "text-primary" })
    ]),
    _: 1
  }))
}
}

})